/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_Resume_DescInputs */

const en_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Work history, education, skills, and other CV content you provide — Legal basis: Contract performance (Art. 6(1)(b) GDPR)`)
};

const de_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Berufserfahrung, Ausbildung, Faehigkeiten und andere von Ihnen bereitgestellte Lebenslaufinhalte — Rechtsgrundlage: Vertragserfuellung (Art. 6 Abs. 1 lit. b DSGVO)`)
};

const fr_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Expérience professionnelle, formation, compétences et autres contenus de CV que vous fournissez`)
};

const es_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Experiencia laboral, educación, habilidades y otros contenidos del CV que usted proporciona`)
};

const it_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Esperienze lavorative, istruzione, competenze e altri contenuti del CV forniti`)
};

const nl_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Werkervaring, opleiding, vaardigheden en andere door u verstrekte CV-inhoud`)
};

const pl_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Historia zatrudnienia, wykształcenie, umiejętności i inne podane treści CV`)
};

const fi_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Työhistoria, koulutus, taidot ja muu antamasi CV-sisältö`)
};

const da_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Arbejdshistorik, uddannelse, færdigheder og andet CV-indhold du angiver`)
};

const sv_privacy_data_processing_item_resume_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Arbetshistorik, utbildning, färdigheter och annat CV-innehåll du tillhandahåller`)
};

/**
* | output |
* | --- |
* | "Work history, education, skills, and other CV content you provide — Legal basis: Contract performance (Art. 6(1)(b) GDPR)" |
*
* @param {Privacy_Data_Processing_Item_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_resume_desc = /** @type {((inputs?: Privacy_Data_Processing_Item_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "es") return es_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "it") return it_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "da") return da_privacy_data_processing_item_resume_desc(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_resume_desc(inputs)
	return en_privacy_data_processing_item_resume_desc(inputs)
});